<template>
  <v-app-bar app flat style="border-bottom: 1px solid #E0E0E0;">
    <v-toolbar-items>
      <v-btn icon :class="{'ml-n3': isMobile}" @click="toggleDrawer({ target: 'appMenu' })">
        <v-icon>mdi-menu</v-icon>
      </v-btn>
    </v-toolbar-items>
    <v-toolbar-title class="pl-3">{{ breadcrumbs.join(' - ') }}</v-toolbar-title>
    <v-progress-circular
      v-if="ajaxing"
      indeterminate
      size="24"
      color="primary"
      class="ml-3"
    ></v-progress-circular>
    <v-spacer></v-spacer>
    <v-toolbar-items class="hidden-xs-only">
      <v-btn text @click="toggleDrawer({ target: 'appMessage' })">
        <span>我的消息</span>
        <v-badge
          v-show="messages > 0"
          inline
          color="error"
          :content="messages"
          :value="messages"
        ></v-badge>
      </v-btn>
      <v-divider inset vertical></v-divider>
      <v-btn text @click="manualLogout">退出登录</v-btn>
    </v-toolbar-items>
  </v-app-bar>
</template>

<script>
  import { mapState } from 'vuex'
  import drawer from '../../../../mixins/drawer'

  export default {
    name: 'app-toolbar',
    mixins: [drawer],
    computed: {
      ...mapState({
        pages: state => state.pages,
        ajaxing: state => state.ajaxing,
        logoutTag: state => state.logoutTag,
        messages: state => state.messages,
      }),
      breadcrumbs () {
        const breadcrumbs = []
        const segments = this.$route.path.split('/')
        _.forEach(segments, (segment, index) => {
          const path = segments.slice(0, index + 1).join('/')
          const page = _.find(this.pages, {
            path: path
          })
          if (page) {
            breadcrumbs.push(page.title)
          }
        })
        return breadcrumbs
      }
    },
    methods: {
      manualLogout () {
        this.$store.commit('assignValue', {
          logoutTag: this.logoutTag + 1
        })
      }
    }
  }
</script>
